import { lazy } from 'react';

const Dashboard = lazy(() =>
  import('../../components/pages/Dashboard/Dashboard'),
);
const Slider = lazy(() => import('../../components/pages/Slider/Slider'));
const RepairOrderDetails = lazy(() =>
  import('../../components/features/RepairOrderDetails/RepairOrderDetails'),
);

export const operationsRoutes = [
  {
    path: '/dashboard',
    permission: 'dashboard.view',
    access: 'authenticated',
    roles: ['ADMIN', 'KONTROLER'],
    Component: Dashboard,
  },
  {
    path: '/slider',
    permission: 'dashboard.view',
    access: 'authenticated',
    roles: ['ADMIN', 'KONTROLER'],
    Component: Slider,
  },
  {
    path: '/repair-order/:id',
    permission: 'pz04.repair',
    access: 'authenticated',
    roles: ['ADMIN', 'KONTROLER'],
    Component: RepairOrderDetails,
  },
];
